import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  getStoreForwardConsultaUrl,
  getStoreForwardIntentosUrl,
  getStoreForwardOperacionesUrl,
} from '../base/url.store-forward.gateway';
import {
  StoreForwardAttemptRequest,
  StoreForwardOperationRequest,
  StoreForwardQueryRequest,
  StoreForwardResponse,
} from '../logging/store-forward.types';

@Injectable({ providedIn: 'root' })
export class StoreForwardOperacionesGatewayApi {
  constructor(private readonly http: HttpClient) {}

  registerOperation(body: StoreForwardOperationRequest): Observable<StoreForwardResponse> {
    return this.http.post<StoreForwardResponse>(getStoreForwardOperacionesUrl(), body);
  }

  registerAttempt(body: StoreForwardAttemptRequest): Observable<StoreForwardResponse> {
    return this.http.post<StoreForwardResponse>(getStoreForwardIntentosUrl(), body);
  }

  query(body: StoreForwardQueryRequest): Observable<StoreForwardResponse> {
    return this.http.post<StoreForwardResponse>(getStoreForwardConsultaUrl(), body);
  }
}
